import checkAll from "@github/check-all";
import { on } from "delegated-events";
import { observe } from "selector-observer";
import { addClasses, parseClassList, removeClasses, } from "../utils/classes";
// Wire up the check-all helper that we build on below.
observe("[data-check-all-container]", {
    constructor: HTMLElement,
    subscribe: checkAll,
});
// Adds a label toggle to the check/uncheck all button.
on("change", "[data-check-all]", (event) => {
    const target = event.target;
    const container = target.closest("[data-check-all-container]");
    if (!container) {
        console.error("Could not find container for input", target);
        return;
    }
    const selectAllText = container.querySelector("[data-select-all-text]");
    const deselectAllText = container.querySelector("[data-all-selected-text]");
    selectAllText === null || selectAllText === void 0 ? void 0 : selectAllText.toggleAttribute("hidden", target.checked);
    deselectAllText === null || deselectAllText === void 0 ? void 0 : deselectAllText.toggleAttribute("hidden", !target.checked);
});
function styleElementState({ container, selected, }) {
    const toggleContainers = [container, ...container.querySelectorAll("[selected-class]")];
    for (const element of toggleContainers) {
        const defaultClasses = parseClassList(element.getAttribute("default-class"));
        const selectedClasses = parseClassList(element.getAttribute("selected-class"));
        if (selected) {
            removeClasses(element, ...defaultClasses);
            addClasses(element, ...selectedClasses);
        }
        else {
            removeClasses(element, ...selectedClasses);
            addClasses(element, ...defaultClasses);
        }
    }
}
// Toggle the default/selected classes on all elements inside of the input's container.
on("change", "[data-check-all-item]", (event) => {
    const target = event.target;
    const container = target.closest("[data-check-all-item-container]");
    if (!container) {
        return;
    }
    // If input is a radio button we need to toggle all styles back to default before styling the selected one
    if (target.type === "radio") {
        const checkAllContainer = container.closest("[data-check-all-container]");
        if (!checkAllContainer) {
            console.error("Could not find check-all input", target);
            return;
        }
        const containers = [...checkAllContainer.querySelectorAll("[data-check-all-item-container]")];
        for (const element of containers) {
            styleElementState({
                container: element,
                selected: false,
            });
        }
    }
    styleElementState({
        container,
        selected: target.checked,
    });
});
// Toggle the required attribute on all inputs with the same name as the check-all input.
// This will prevent the form from being submitted if none of the check-all inputs are checked.
on("change", "[data-check-all-item]", (event) => {
    const target = event.target;
    const form = target.closest("form");
    if (!form) {
        console.error("Could not find form for input", target);
        return;
    }
    const checkboxes = [...form.querySelectorAll(`input[name="${target.name}"]`)];
    const anyChecked = checkboxes.some((checkbox) => checkbox.checked);
    for (const checkbox of checkboxes) {
        checkbox.required = !anyChecked;
    }
}, {
    // Needed to ensure the required attribute is set before the form is validated
    capture: true,
});
